"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllGroupRoleBranchesRequest = getAllGroupRoleBranchesRequest;
exports.getGroupRoleBranchesRequest = getGroupRoleBranchesRequest;
exports.patchGroupRoleBranchesRequest = patchGroupRoleBranchesRequest;
async function getAllGroupRoleBranchesRequest(branchId, userId) {
    try {
        const response = await fetch(`/dashboard/${userId}/role/groupwide/visibility?c=${branchId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch group role branches`);
        }
        return await response.json();
    }
    catch (err) {
        throw err;
    }
}
async function getGroupRoleBranchesRequest(branchId, userId, params) {
    try {
        const response = await fetch(`/dashboard/${userId}/role/groupwide/visibility/${params.roleId}?c=${branchId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch group role branches`);
        }
        return await response.json();
    }
    catch (err) {
        throw err;
    }
}
async function patchGroupRoleBranchesRequest(branchId, userId, body) {
    const postBody = {
        ToAdd: body.toAdd,
        ToRemove: body.toRemove,
        Special: body.special,
    };
    try {
        const response = await fetch(`/dashboard/${userId}/role/groupwide/visibility/${body.roleId}?c=${branchId}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(postBody),
        });
        if (!response.ok) {
            throw new Error(`Failed to post group role branches`);
        }
    }
    catch (err) {
        throw err;
    }
}
